import { useEffect, useState } from "react";
import { SiteTransport } from "src/app/transports/site";
import { Site } from "src/app/types/Site";

const useGetSiteById = (siteId?: number, initialRequest = true) => {
    const [site, setSite] = useState<Site | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = (siteIdToFetch?: number) => {
        if (!siteIdToFetch) return;
        setLoading(true);
        SiteTransport.getSiteById(siteIdToFetch)
            .then((res) => {
                setSite(res);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (currentSiteId?: number) => {
        if (!loading) fetch(currentSiteId);
    };

    useEffect(() => {
        if (initialRequest) fetch(siteId);
    }, []);

    return { site, refresh, error, loading };
};

export default useGetSiteById;
